declare global {
    interface Window {
        AF?: any;
    }
}

export const trackEvent = (
    eventName: string,
    values: Record<string, any> = {}
) => {
    if (!window.AF) {
        console.warn("AppsFlyer not initialized");
        return;
    }
    window.AF("pba","event", {
        eventType: "EVENT",
        eventName,
        eventValue: {
            platform: "web",
            ...values
        },
    });
};

export const setUserId = (userId: string) => {
    if (!window.AF) {
        console.warn("AppsFlyer not initialized");
        return;
    }
    window.AF("pba", "setCustomerUserId", String(userId));

};